export enum EPage {
  SEARCH = 'search',
  PROMOS = 'promos',
  CAMPGROUND_LISTING = 'campground-rental',
  CAMPGROUND_SEARCH = 'campground-search',
  ONE_WAY_SEARCH = 'one-way',
}

export const PAGE_PATHNAME = {
  [EPage.SEARCH]: '/rv-search',
  [EPage.PROMOS]: '/promos',
  [EPage.CAMPGROUND_LISTING]: '/campground-rental',
  [EPage.CAMPGROUND_SEARCH]: '/campground-search',
  [EPage.ONE_WAY_SEARCH]: '/one-way',
};

export const PAGE_TITLE_SUFFIX = ' | Outdoorsy';
